import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import {
	httpEditExperience,
	type httpEditExperienceOptions
} from '../http/experience-shell.http'
import type { Experience } from '../types'

export const useEditExperience = ({
	experienceId,
	options
}: {
	experienceId: number
	options?: Omit<
		UseMutationOptions<
			Experience,
			unknown,
			httpEditExperienceOptions['payload']
		>,
		'mutationFn'
	>
}) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload) =>
			httpEditExperience({
				urlParams: { experienceId },
				payload,
				params: { responseType: 'extended' }
			}),
		...options,
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE, experienceId]
			})
			queryClient.setQueriesData(
				{ queryKey: [QUERY_KEYS.EXPERIENCE, experienceId] },
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
